import { useEffect, useState } from 'react';
import { fetchContasSicoob, type ContaSicoobInfo } from '../lib/sicoobAccount';

// Contas Sicoob e quais já podem emitir (contas_sicoob). Busca a cada abertura da
// tela, não uma vez por sessão: ligar uma conta é um UPDATE no banco, e quem está
// com o app aberto precisa ver a conta liberada sem recarregar.
//
// `null` = ainda carregando. Falha de leitura vira lista vazia, e conta sem
// informação fica clicável: quem decide de verdade é o banco, que recusa trocar
// a UC para conta não liberada (fn_uc_sincroniza_conta_sicoob).
export function useContasSicoob(enabled: boolean) {
    const [contas, setContas] = useState<ContaSicoobInfo[] | null>(null);

    useEffect(() => {
        if (!enabled) return;
        let vivo = true;
        fetchContasSicoob()
            .then(lista => { if (vivo) setContas(lista); })
            .catch(err => {
                console.warn('Falha ao carregar contas_sicoob', err);
                if (vivo) setContas([]);
            });
        return () => { vivo = false; };
    }, [enabled]);

    return contas;
}
